module.exports = __webpack_public_path__ + "media/images/summary_cards_snapshot_historic-5622c433.png";